<template>

  <div class="relative">
    <div class="flex items-center justify-between p-4 border-b">
      <h3 class="text-xl font-semibold text-gray-900">
        <span v-if="isNew">Add a class</span>
        <span v-else>Edit your class</span>
      </h3>
      <button @click="closeWithoutSaving" class="text-gray-400 hover:text-gray-500">
        <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>

    </div>

    <div class="px-6 py-2">
      <EditClassYogaTypeSelect v-if="isNew"
                               :class-item="classItem"
                               @update:type="handleTypeChange"
      />
      <div v-else>
        <label for="yogaType" class="g--label mt-4  mb-1">
          Yoga Type (Create a new class if you need to edit the yoga type)
        </label>
        {{ classItem.yogaType }}
      </div>

      <label for="price" class="g--label mt-6  mb-1">
        Class description, not shown to students
      </label>
      <p class="text-sm text-gray-800 mb-2">
        This is just for you to help you identify the class in your list.
      </p>
      <input v-model="classData.internalDescription"
             type="text"
             class="g--input w-full"
             placeholder="e.g. 'Lunch class', 'Evening class', etc."/>


      <div class="mt-4">
        <label class="g--label mb-1">Class description, public</label>
        <editor v-model="classData.description"/>
      </div>

      <div class="mt-4">
        <label for="" class="g--label mb-1">Private class</label>
        <p class="text-sm text-gray-800 mb-2">
          Use this for your private clients. The class will not be shown in the listings pages but the direct link will
          still be accessible.
        </p>
        <div class="flex items-start">
          <div class="flex items-center">
            <input v-model="classData.privateClass" id="privateClass"
                   name="fields[privateClass]"
                   type="checkbox"
                   class="cursor-pointer form-checkbox h-4 w-4 text-teal transition duration-150 ease-in-out"></div>
          <div class="ml-3 text-sm leading-5">
            <label for="privateClass" class="cursor-pointer font-medium text-gray-700">
              This is a private class.</label>
          </div>
        </div>

      </div>

      <div class="mt-6">
        <EditClassPrice
            :class-item="classItem"
            @update:price="handlePriceChange"
        />
      </div>
      <div class="mt-6">
        <EditClassTags
            :class-item="classItem"
            @update:tags="handleTagChange"
        />
      </div>
      <div class="mt-8">
        <EditClassVideo
            :class-item="classItem"
            @update:video="handleVideoChange"
        />
      </div>


      <div class="mt-4">
        <div v-if="!classData.yogaTypeId" class="text-red text-sm mb-1">Please select a yoga type.</div>
        <div v-if="!classData.priceGBP" class="text-red text-sm mb-1">Please select a price.</div>
        <div v-if="needsVideoLink && !classData.teacherProvidedZoomLink" class="text-red text-sm mb-1">Please enter a
          zoom
          link.
        </div>
        <div v-if="saveError" class="text-red text-sm mb-1">{{ saveErrorMessage }}</div>
        <div class="h-[42px] flex items-center justify-center" v-if="saving">
          <Spinner></Spinner>
        </div>
        <button
            v-if="!saving"
            class="g--button  w-full"
            :disabled="invalidClass"
            :class="{
                  'g--button--active': !invalidClass,
                  'g--button--gray opacity-75 cursor-not-allowed': invalidClass
                }"
            @click="saveClass()">Save
        </button>
      </div>
      <div class="mt-4 flex items-center justify-end">
        <button class="hover:underline text-sm" @click="closeWithoutSaving()">Close without saving</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import EditClassPrice from './EditClassPrice.vue';
import EditClassYogaTypeSelect from './EditClassYogaTypeSelect.vue';
import EditClassTags from './EditClassTags.vue';
import EditClassVideo from './EditClassVideo.vue';
import Editor from './Editor.vue';
import Spinner from './Spinner.vue';

const props = defineProps({
  classItem: {
    type: Object,
    required: true,
  },
  needsVideoLink: {
    type: Boolean,
    default: false,
  }
});

const saveError = ref(false);
const saveErrorMessage = ref('');
const classData = ref({
  ...props.classItem
});

const isNew = ref(false);
const invalidClass = computed(() => {
  console.log(classData.value.priceGBP);
  return (!classData.value.teacherProvidedZoomLink && props.needsVideoLink) || !classData.value.yogaTypeId || !classData.value.priceGBP || !classData.value.priceUSD || !classData.value.priceEUR;
});

const saving = ref(false);

onMounted(() => {

  if (Object.keys(props.classItem).length == 0) {
    isNew.value = true;
    // classData.value = {
    //   yogaTypeId: null,
    //   priceGBP: 0,
    //   priceUSD: 0,
    //   priceEUR: 0,
    //   tagsIds: [],
    //   teacherProvidedZoomLink: ''
    // };
  } else {
  }
  classData.value.internalDescription = props.classItem.classDescriptionTeacher;
  console.log(props.classItem);
  console.log(classData.value);
});

const handleTypeChange = async (newTypeId) => {
  classData.value.yogaTypeId = newTypeId;
};

const handlePriceChange = async (newPrice) => {
  classData.value.priceGBP = newPrice.priceGBP;
  classData.value.priceUSD = newPrice.priceUSD;
  classData.value.priceEUR = newPrice.priceEUR;
};

const handleTagChange = async (newTags) => {
  console.log(newTags);
  classData.value.tagsIds = newTags;
};

const handleVideoChange = async (newVideo) => {
  classData.value.teacherProvidedZoomLink = newVideo;
};


const emit = defineEmits(['entry-saved']);


const saveClass = async () => {
  // Save the class data
  console.log(props.classItem);
  saving.value = true;
  try {
    let data = {
      entryId: isNew.value ? null : props.classItem.id,
      sectionId: 3,
      enabled: true,

      fields: {
        yogaType: [classData.value.yogaTypeId],
        tags: classData.value.tagsIds,
        classDescriptionTeacher: classData.value.internalDescription,
        classDescription: classData.value.description,
        teacherProvidedZoomLink: classData.value.teacherProvidedZoomLink,
        privateClass: classData.value.privateClass ? 1 : 0,
        priceGbp: classData.value.priceGBP * 100 || 0,
        priceUsd: classData.value.priceUSD * 100 || 0,
        priceEur: classData.value.priceEUR * 100 || 0
      }
    };
    data[csrfTokenName] = csrfTokenValue;

    const response = await fetch('/actions/entries/save-entry', {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw JSON.stringify(errorData.errors);
    }

    const savedEntry = await response.json();
    saving.value = false;
    // Optional: Emit the saved entry data
    emit('entry-saved', savedEntry);

    return savedEntry;

  } catch (error) {
    console.error('Error saving entry:', error);
    saving.value = false;
    let errors = JSON.parse(error);
    if (errors.teacherProvidedZoomLink) {
      saveError.value = true;
      saveErrorMessage.value = 'Please enter a valid Zoom or Google Meet link.';
    }
  }
};


const closeWithoutSaving = () => {
  emit('entry-saved', props.classItem);
};


</script>